<template>
  <div ref="embedded" id="winner">
    <div v-if="lastWinner">
      <img src="/static/images/logo_white.svg" class="background-logo" alt />
      <div class="row">
        <div class="col-3 image-col">
          <div class="image-wrapper">
            <user-image :user="lastWinner.user" />
            <img class="rank-image" :src="rankUrl" alt />
          </div>
        </div>
        <div class="col-9 reason-col">
          <div class="row">
            <div class="col-12">
              <h2 class="title">{{$t('embedded.winner.title')}}</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h1 class="winner-name">{{lastWinner.user.firstName}}</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <carousel
                class="carousel"
                :center="true"
                :dots="true"
                :nav="false"
                :autoplay="true"
                :autoWidth="false"
                :responsive="responsive"
              >
                <div
                  class="reason"
                  v-for="(transaction, index) in lastWinner.transactions"
                  :key="index"
                >"{{transaction.reason}}"</div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      Powered by
      <a href="http://app.motivac.io" target="_blank">motivac.io</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserImage from '@/components/shared/users/UserImage';

export default {
  name: 'EmbeddedScreen',
  components: {
    UserImage,
  },
  data() {
    return {
      lastWinner: undefined,
      responsive: {
        0: {
          items: 1,
        },
      },
    };
  },
  async created() {
    this.lastWinner = await this.fetchLastWinner({
      externalApiKey: this.$route.params.externalApiKey,
    });
  },
  mounted() {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;
      const height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      );
      window.parent.postMessage({ documentHeight: height }, '*');
    }, 550);
  },
  methods: {
    ...mapActions({
      fetchLastWinner: 'histories/fetchLastWinner',
    }),
  },
  computed: {
    rankUrl() {
      if (this.lastWinner.user.won / 3 > 3) {
        return '/static/images/rank_2.svg';
      } else if (this.lastWinner.user.won / 3 >= 2) {
        return '/static/images/rank_1.svg';
      }
      return '/static/images/rank_0.svg';
    },
  },
};
</script>
<style lang="scss" scoped>
html,
body {
  background-color: transparent;
}
#app {
  min-height: unset;
  background-color: transparent;
  height: auto;
  overflow: auto;
}
#winner {
  padding: 5%;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: rgb(51, 128, 195);
  background: linear-gradient(
    90deg,
    rgba(51, 128, 195, 1) 0%,
    rgba(98, 45, 144, 1) 49%
  );
  background-size: cover;
  background-position-y: 50%;
  background-repeat: no-repeat;
  border-radius: 8px;
  .image-col {
    display: flex;
    justify-content: center;
    align-items: center;
    .image-wrapper {
      border-radius: 50%;
      max-width: 50vw;
      border: 0.5vw solid white;
      position: relative;
      .rank-image {
        max-width: 5vw;
        position: absolute;
        bottom: 5%;
        left: 0;
        background-color: white;
        border-radius: 50%;
        padding: 5%;
      }
    }
  }
  .reason-col {
    padding: 1%;
  }
  .title,
  .winner-name {
    color: white;
  }
  .title {
    font-size: 3vw;
  }
  .winner-name {
    font-size: 5vw;
  }
  .background-logo {
    opacity: 0.1;
    position: absolute;
    height: 200%;
    top: -10%;
  }
  .carousel {
    width: 100%;
    >>> .owl-dots {
      .owl-dot {
        &.active span {
          background-color: rgba(255, 255, 255, 0.9);
        }
        span {
          background-color: rgba(0, 0, 0, 0.2);
          width: 1vw;
          height: 1vw;
        }
      }
    }
    .reason {
      color: white;
      font-size: 3vw;
      width: 75%;
      margin: 0 auto;
      font-style: italic;
    }
  }
  .footer {
    position: absolute;
    right: 2%;
    bottom: 2%;
    color: white;
    font-size: 1.2vw;
    a {
      color: white;
    }
  }
}
</style>
